export class DoctorsModel{
  docCode = '';
  docName = '';
  docAddress = '';
  docPhone ='';
  docMobile = '';
  docmail ='';
  docDepartment = '';
  docTitle ='';
  docWPhone = '';
  docWMMobile = '';
  docWmail = '';
  docUser ='';
  compCode = '1';
  userID = 'sa';
  modifiedDate = '2021-01-01';
}

